<section class="sd-radio" :class="{'sd-radio__error': isRequired}" ref="radio">
    <h6 class="sd-radio__label">{{ label }}</h6>
    <section class="sd-radio__item-wrapper" :class="positionItem">
        <section
                class="sd-radio__item"
                :class="{'c-not-allowed': disabled}"
                v-for="(option, key) in options"
                :key="key"
                :title="$t(option.text) ? $t(option.text) : $t(option)"
        >
            <section
                    class="sd-radio__custom-fake"
                    :class="{'checked': content == key, 'disabled': disabled, 'error': isRequired}"
                    @click="content = key"
            >
                <input
                        type="radio"
                        :required="required"
                        :name="name"
                        :disabled="disabled"
                        :value="option.value != null ? option.value : key"
                        v-model="content"
                        class="sd-radio__input"
                        :data-test-id="'input-radio_' + (option.text || option)"
                />
                <span class="sd-radio__custom-icon" v-if="content == key">
                    <i class="fas fa-check"></i>
                </span>
            </section>
            <span :class="{'sd-radio__text--disabled': disabled}" class="sd-radio__text">{{ $t(option.text) || $t(option) }}</span>
        </section>
    </section>
</section>